import React from 'react'
import { motion } from 'framer-motion'
import { fadeIn } from '../variants'
import { Link } from 'react-router-dom';
import Img1 from '../assets/nexmind/nexmind_1.avif'
import Img2 from '../assets/morifarm/morifarm_3-resized.png'
import Img3 from '../assets/techtrove/techtrove_1.png'
function Projects() {
  return (
    <div id='projects' className='section'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row gap-x-10'>
          {/* left side */}
          <motion.div
            variants={fadeIn('right', 0.5)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
            <div className='lg:h-[268px] flex flex-col justify-between'>
              <h2 className='h2 leading-tight text-accent'>
                My Latest Work.
              </h2>
              <p className='max-w-sm mb-6'>
                Screenshots of some of my latest projects from previous jobs, university projects showcasing what I’ve  been up to in the world of web development as a frontend developer.
              </p>
              <h3 className='h3 text-accent mb-14'>
                Click to see more
              </h3>
              {/* <button className='btn btn-sm w-60'>View All projects</button> */}
            </div>
            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              <Link to="/gallery-morifarm">
                <div className='group-hover:bg-black/80 w-full h-full absolute z-40 transition-all duration-300'></div>
                <img className='group-hover:scale-125 transition-all duration-500' src={Img2} alt="" />
                <div className='absolute -bottom-full left-12 group-hover:bottom-32 transiton-all duration-500 z-50'>
                  <span className='text-gradient'>Frontend Developer at IOT Advance</span>
                </div>
                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transiton-all duration-700 z-50'>
                  <span className='text-3xl text-white'>MoriFarm Dashboard</span>
                  <p>Click to see more</p>
                </div>
              </Link>
            </div>
          </motion.div>
          {/* right side */}
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0 justify-between'>

            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              <Link to="/gallery-nexmind">
                <div className='group-hover:bg-black/80 w-full h-full absolute z-40 transition-all duration-300'></div>
                <img className='group-hover:scale-125 transition-all duration-500' src={Img1} alt="" />
                <div className='absolute -bottom-full left-12 group-hover:bottom-32 transiton-all duration-500 z-50'>
                  <span className='text-gradient'>Frontend Developer at Nexmind AI</span>
                </div>
                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transiton-all duration-700 z-50'>
                  <span className='text-3xl text-white'>Nexmind AI Dashboard</span>
                  <p>Click to see more</p>
                </div>
              </Link>
            </div>
            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              <Link to="/gallery-techtrove">
                <div className='group-hover:bg-black/80 w-full h-full absolute z-40 transition-all duration-300'></div>
                <img className='group-hover:scale-125 transition-all duration-500' src={Img3} alt="" />
                <div className='absolute -bottom-full left-12 group-hover:bottom-32 transiton-all duration-500 z-50'>
                  <span className='text-gradient'>QUT Assignment - Python Flask Application</span>
                </div>
                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transiton-all duration-700 z-50'>
                  <span className='text-3xl text-white'>Tech Gadget E-Commerce Store</span>
                  <p>Click to see more</p>
                </div>
              </Link>

            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Projects
